import { Toolbar } from '@components/App/Toolbar'
import { ProjectInfoMenu } from '@components/ArtBoard/Footer/components/ProjectInfoMenu'
import type React from 'react'

import {
  useActiveFolder,
  useInboxUnread,
  useSidebarToggle,
  useTemplatesPrefetch,
  useWorkspaces,
  useWorkspacesRoot,
} from '../../hooks'
import {
  AsideContainer,
  DashboardHeader,
  DashboardLoader,
  DashboardOverlay,
  DashboardTutorial,
  ExpiredView,
  WorkspaceSidebar,
} from './components'
import css from './styles.module.css'

export const DashboardLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { open, opened, close } = useSidebarToggle()
  const { current, folderId, workspaces, workspaceId } = useWorkspaces()

  const activeFolder = useActiveFolder(folderId)

  const { loading } = useWorkspacesRoot(current, workspaces)

  useTemplatesPrefetch(workspaceId)
  useInboxUnread(workspaceId)

  const expired = current?.expired

  if (loading || !current) {
    return <DashboardLoader />
  }

  return (
    <div className={css.dashboard_layout}>
      <DashboardOverlay shown={opened} onClick={close} />
      <AsideContainer opened={opened}>
        <WorkspaceSidebar
          current={current}
          activeFolder={activeFolder}
          workspaces={workspaces}
          onCloseSidebar={open}
        />
      </AsideContainer>
      <main className={css.dashboard_main}>
        <DashboardHeader workspace={current} onOpenSidebar={open} />
        <div className={css.content_area}>
          {expired ? (
            <ExpiredView id={current.id} features={current.features} />
          ) : (
            children
          )}
        </div>

        <DashboardTutorial />
        <div className={css.help_menu}>
          <Toolbar>
            <ProjectInfoMenu />
          </Toolbar>
        </div>
      </main>
    </div>
  )
}
